import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    marginTop: theme.spacing(4),
    '&> div': {
      borderTop: `1px solid ${theme.colorPalette.white_30_op_30} `
    },
    '&> div:first-child': {
      borderTop: 'none'
    },
    marginBottom: theme.spacing(4),
    padding: theme.spacing(4, 6),
    minHeight: 60,
    boxShadow: ({ noShadow }) => (noShadow ? 'none !important' : '0px 0px 10px rgba(0, 0, 0, 0.1)')
  },
  sideBySideContainer: {
    extend: 'container',
    display: 'flex',
    gap: theme.spacing(3),
    alignItems: 'center',
    boxShadow: ({ noShadow }) => (noShadow ? 'none !important' : '0px 0px 10px rgba(0, 0, 0, 0.1)')
  },
  columnContainer: {
    width: '100%',
    marginTop: theme.spacing(4),
    padding: theme.spacing(4, 6),
    minHeight: 60,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxShadow: ({ noShadow }) => (noShadow ? 'none !important' : '0px 0px 10px rgba(0, 0, 0, 0.1)')
  },
  primary: {
    backgroundColor: theme.colorPalette.orange_50,
    color: theme.colorPalette.white_10
  },
  secondary: {
    backgroundColor: theme.colorPalette.white_10,
    color: theme.colorPalette.green_30
  },
  tertiary: {
    backgroundColor: theme.colorPalette.green_10,
    color: theme.colorPalette.white_10
  },
  quaternary: {
    backgroundColor: theme.colorPalette.green_30,
    color: theme.colors.light_text
  },
  light: {
    backgroundColor: theme.colorPalette.beige_10,
    color: theme.colorPalette.green_20
  },
  infoGreen: {
    extend: 'light'
  },
  infoWhite: {
    extend: 'noBackground'
  },
  noBackground: {
    display: 'flex',
    color: theme.colors.light_text,
    backgroundColor: 'transparent',
    fontSize: 20,
    margin: 0,
    alignItems: 'center',
    '&> img': {
      marginRight: 0
    }
  },
  icon: {
    width: 30,
    height: 30
  },
  icon16: {
    width: 16,
    height: 16
  },
  icon16Bold: {
    width: 16,
    height: 16
  },
  headerRow: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    gap: theme.spacing(2),
    justifyContent: 'flex-start'
  },
  notificationContentContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  outline: {
    borderRadius: 8,
    border: `2px solid ${theme.colorPalette.beige_10}`,
    backgroundColor: 'transparent',
    boxShadow: 'none'
  },
  header: {
    marginBottom: theme.spacing(2)
  }
}));

export default useStyles;
